<template>
  <section>
    <aRow :gutter="[20, 0]">
      <aCol :span="5">
        <aFormItem>
          <label for class="filled">Valor total do boleto (R$)</label>
          <aInput
            class="travel-input"
            placeholder="Insira"
            v-currency
            @keyup="updateTotalValue"
            v-decorator="[
              `payment_methods_billing_ticket_total_value${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório.',
                  },
                  {
                    validator: verifyValue,
                  },
                ],
              },
            ]"
          >
            <aIcon slot="prefix" type="field-svg" />
          </aInput>
        </aFormItem>
      </aCol>

      <aCol :span="7">
        <aFormItem>
          <label for class="filled">Emissor</label>
          <a-select
            class="travel-input select"
            placeholder="Selecione"
            @change="onSelectBillingTicketTax"
            allowClear
            v-decorator="[
              `payment_methods_billing_ticket_tax_id${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) of billingTickets.list"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </aFormItem>
      </aCol>

      <aCol
        v-if="
          form.getFieldValue(
            `payment_methods_billing_ticket_tax_id${keySuffix}`
          ) != undefined
        "
        :span="4"
      >
        <aFormItem>
          <label for class="filled">Parcelas </label>
          <a-select
            class="travel-input select"
            placeholder="Parcelas"
            :disabled="
              form.getFieldValue(
                `payment_methods_billing_ticket_total_value${keySuffix}`
              ) != undefined &&
              form.getFieldValue(
                `payment_methods_billing_ticket_total_value${keySuffix}`
              ) != ''
                ? false
                : true
            "
            @change="calcBillingTicketInstallments"
            v-decorator="[
              `payment_methods_billing_ticket_installments${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) of billingTicket.installments"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </aFormItem>
      </aCol>

      <aCol
        v-if="
          form.getFieldValue(
            `payment_methods_billing_ticket_tax_id${keySuffix}`
          ) != undefined
        "
        :span="4"
      >
        <aFormItem>
          <label for class="filled">Total Taxas (R$)</label>

          <aInput
            class="travel-input"
            placeholder="Total Taxas (R$)"
            :disabled="true"
            v-decorator="[
              `payment_methods_billing_ticket_tax_value${keySuffix}`,
            ]"
          >
            <aIcon slot="prefix" type="field-svg" />
          </aInput>
        </aFormItem>
      </aCol>
    </aRow>

    <aRow
      v-for="(field, index) in billingTicket.installmentsFields"
      :key="index"
      :gutter="[20, 0]"
    >
      <aCol :span="5">
        <aFormItem>
          <label for class="filled">Valor da {{ field.id }}ª parcela</label>
          <aInput
            class="travel-input"
            v-currency
            :placeholder="`Valor da ${field.id}ª parcela`"
            v-decorator="[
              `payment_methods_billing_ticket_installment_${field.id}${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
            <aIcon slot="prefix" type="field-svg" />
          </aInput>
        </aFormItem>
      </aCol>
      <aCol :span="7">
        <aFormItem class="travel-input">
          <label for class="filled">Vencimento ({{ field.id }}ª parcela)</label>

          <a-date-picker
            class="travel-input"
            :placeholder="`Vencimento (${field.id}ª parcela)`"
            format="DD/MM/YYYY"
            v-mask="'##/##/####'"
            :showToday="false"
            :disabled-date="minDate"
            @change="selectExpirationDate(field.id)"
            v-decorator="[
              `payment_methods_billing_ticket_installment_${field.id}_expiration_date${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    message: 'Obrigatório',
                  },
                ],
              },
            ]"
          >
          </a-date-picker>
        </aFormItem>
      </aCol>
    </aRow>

    <aRow>
      <aCol :span="5">
        <aFormItem>
          <label for class="filled">CPF</label>
          <aInput
            class="travel-input"
            placeholder="Insira o cpf"
            v-mask="'###.###.###-##'"
            v-decorator="[
              `payment_methods_billing_ticket_CPF${keySuffix}`,
              {
                rules: [
                  {
                    required: true,
                    min: 9,
                    message: 'Preencha todos números.',
                  },
                ],
              },
            ]"
          >
            <aIcon slot="prefix" type="field-svg" />
          </aInput>
        </aFormItem>
      </aCol>

      <aCol class="mt-20" :span="24">
        <aFormItem class="textarea form-item">
          <label for class="filled">Observações</label>

          <aInput
            class="travel-textarea"
            placeholder="Insira alguma observação sobre o boleto"
            type="textarea"
            v-decorator="[
              `payment_methods_billing_ticket_observation${keySuffix}`,
            ]"
          >
          </aInput>
        </aFormItem>
      </aCol>
    </aRow>
  </section>
</template>

<script>
import { parse } from "vue-currency-input";
import { add, sub } from "date-fns";
import formatThings from "@/mixins/general/formatThings.js";
import billingTicketsMixins from "@/mixins/billing-tickets/billingTicketsMixins.js";

export default {
  name: "BillingTicketTabModal",
  props: {
    form: Object,
    contract: Object,
    tempContract: Object,
    keyPrefix: String,
    keySuffix: String,
    reservation_total_price: Number,
  },
  mixins: [formatThings, billingTicketsMixins],
  data() {
    return {
      billingTicket: {
        installments: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        installmentsFields: [],
      },
    };
  },
  mounted() {
    this.billingTickets.filters.status.selected = "Ativo";
    this.getBillingTickets();
    this.setFormFieldsValue();
    this.updateTotalValue();
  },
  methods: {
    updateTotalValue() {
      this.$emit("updateTotalValue");
    },
    setFormFieldsValue() {
      this.form.setFieldsValue({
        [`payment_methods_billing_ticket_CPF${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_billing_ticket_CPF${this.keySuffix}`
          ],
        [`payment_methods_billing_ticket_tax_id${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_billing_ticket_tax_id${this.keySuffix}`
          ],
        [`payment_methods_billing_ticket_total_value${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_billing_ticket_total_value${this.keySuffix}`
          ],
        [`payment_methods_billing_ticket_observation${this.keySuffix}`]:
          this.tempContract[
            `payment_methods_billing_ticket_observation${this.keySuffix}`
          ],
      });

      if (
        this.tempContract[
          `payment_methods_billing_ticket_installments${this.keySuffix}`
        ] != undefined
      ) {
        let installments = parseInt(
          this.tempContract[
            `payment_methods_billing_ticket_installments${this.keySuffix}`
          ]
        );

        this.billingTicket.installmentsFields = [];

        for (let i = 1; i < installments + 1; i++) {
          this.billingTicket.installmentsFields.push({ id: i });
        }
      }

      setTimeout(() => {
        this.form.setFieldsValue({
          [`payment_methods_billing_ticket_installments${this.keySuffix}`]:
            this.tempContract[
              `payment_methods_billing_ticket_installments${this.keySuffix}`
            ],
          [`payment_methods_billing_ticket_tax_value${this.keySuffix}`]:
            this.tempContract[
              `payment_methods_billing_ticket_tax_value${this.keySuffix}`
            ],
        });

        this.billingTicket.installmentsFields.forEach((installment) => {
          this.form.setFieldsValue({
            [`payment_methods_billing_ticket_installment_${installment.id}${this.keySuffix}`]:
              this.tempContract[
                `payment_methods_billing_ticket_installment_${installment.id}${this.keySuffix}`
              ],
            [`payment_methods_billing_ticket_installment_${installment.id}_expiration_date${this.keySuffix}`]:
              this.tempContract[
                `payment_methods_billing_ticket_installment_${installment.id}_expiration_date${this.keySuffix}`
              ],
          });
        });
      }, 20);
    },
    onSelectBillingTicketTax(taxId) {
      if (taxId != undefined) {
        let tax = this.billingTickets.list.filter((e) => {
          return e.id == taxId;
        });

        this.billingTicket.installmentsFields = [];

        this.form.setFieldsValue({
          [`payment_methods_billing_ticket_installments${this.keySuffix}`]:
            undefined,
          [`payment_methods_billing_ticket_tax_value${this.keySuffix}`]:
            undefined,
        });

        if (tax[0] != undefined) {
          this.form.setFieldsValue({
            [`payment_methods_billing_ticket_taxes_range${this.keySuffix}`]:
              tax[0].taxes_range,
          });
        } else {
          this.form.setFieldsValue({
            [`payment_methods_billing_ticket_taxes_range${this.keySuffix}`]:
              "[]",
          });
          setTimeout(() => {
            this.tempContract[
              `payment_methods_billing_ticket_tax_id${this.keySuffix}`
            ] = "";
          }, 20);
        }
      } else {
        this.billingTicket.installmentsFields = [];
        this.tempContract[
          `payment_methods_billing_ticket_installments${this.keySuffix}`
        ] = undefined;
      }
    },
    minDate(current) {
      return (
        sub(new Date(), {
          days: 1,
        }) > current
      );
    },
    selectExpirationDate(id) {
      if (id == 1) {
        setTimeout(() => {
          let newExpirationDate = null,
            val =
              this.tempContract[
                `payment_methods_billing_ticket_installment_${id}_expiration_date${this.keySuffix}`
              ];

          this.billingTicket.installmentsFields.forEach((installment) => {
            setTimeout(() => {
              newExpirationDate = `${add(val._d, {
                months: installment.id - 1,
              })}`;

              this.form.setFieldsValue({
                [`payment_methods_billing_ticket_installment_${installment.id}_expiration_date${this.keySuffix}`]:
                  newExpirationDate,
              });
            }, 20);
          });
        }, 20);
      }
    },
    calcBillingTicketInstallments() {
      let billingTicketValue =
          this.tempContract[
            `payment_methods_billing_ticket_total_value${this.keySuffix}`
          ],
        installments = 1,
        taxesRange =
          this.tempContract[
            `payment_methods_billing_ticket_taxes_range${this.keySuffix}`
          ],
        selectedTax = "";

      setTimeout(() => {
        installments = this.tempContract[
          `payment_methods_billing_ticket_installments${this.keySuffix}`
        ]
          ? parseInt(
              this.tempContract[
                `payment_methods_billing_ticket_installments${this.keySuffix}`
              ]
            )
          : 1;

        if (taxesRange) {
          taxesRange = JSON.parse(taxesRange);
          selectedTax = taxesRange.filter((e) => {
            return e.id == installments;
          });
        } else {
          selectedTax = "";
          taxesRange = [];
        }

        let totalTaxes = 0;
        let totalPercentage = 0;
        taxesRange.forEach((tax) => {
          if (parseInt(tax.id) <= installments) {
            let thetax = tax.value.replace("R$ ", "").replace(",", ".");
            let thePercentage = tax.percentage.replace("%", "");

            totalTaxes += parseFloat(thetax);
            totalPercentage = parseFloat(thePercentage);
          }
        });

        selectedTax;

        if (billingTicketValue) {
          billingTicketValue = billingTicketValue.replace(",", ".");
          billingTicketValue = parseFloat(billingTicketValue);
        }

        let thePercentageDiscount = 0;
        let totalTaxesBillingTicket = 0;

        thePercentageDiscount = (totalPercentage / 100) * billingTicketValue;

        totalTaxesBillingTicket = thePercentageDiscount + totalTaxes;

        this.tempContract[
          `payment_methods_billing_ticket_tax_value${this.keySuffix}`
        ] = totalTaxesBillingTicket
          ? this.formatPrice(totalTaxesBillingTicket)
          : 0;

        if (billingTicketValue) {
          let monthlyInstallments = [],
            installmentsFields = [];

          for (let i = 1; i < installments + 1; i++) {
            monthlyInstallments.push(billingTicketValue / installments);
            installmentsFields.push({ id: i });
          }

          this.billingTicket.installmentsFields = installmentsFields;

          this.tempContract[
            `payment_methods_billing_ticket_installments_rows${this.keySuffix}`
          ] = JSON.stringify(installmentsFields);

          this.form.setFieldsValue({
            [`payment_methods_billing_ticket_installment_1${this.keySuffix}`]:
              this.formatPrice(monthlyInstallments[0]),
          });

          this.billingTicket.installmentsFields.forEach((installment) => {
            setTimeout(() => {
              this.form.setFieldsValue({
                [`payment_methods_billing_ticket_installment_${installment.id}${this.keySuffix}`]:
                  this.formatPrice(monthlyInstallments[0]),
              });
            }, 10);
          });
        }

        this.form.setFieldsValue({
          [`payment_methods_billing_ticket_tax_value${this.keySuffix}`]:
            totalTaxesBillingTicket
              ? this.formatPrice(totalTaxesBillingTicket)
              : 0,
        });
      }, 20);
    },
    async verifyValue(rule, value, callback) {
      rule;
      let theValue = parse(value),
        totalValue = parseFloat(this.reservation_total_price);
      if (isNaN(theValue) || theValue == undefined) {
        theValue = 0;
      } else {
        if (parse(value) > totalValue) {
          callback(
            `O valor preenchido ultrapassa o total da reserva (R$ ${this.reservation_total_price}).`
          );
        } else {
          callback();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-item.textarea {
  position: relative;
  .filled {
    top: -46px;
    opacity: 1 !important;
  }
}
label {
  position: absolute;
  z-index: 4;
  font-size: 10px;
  font-weight: 500;
  color: #ccc;
  transition: 0.3s;
  opacity: 0;
  top: 13px;
  left: 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  &.filled {
    top: -16px;
    opacity: 1 !important;
  }
}
</style>
